type Fonts = {
  Oswald: string;
};

export const fonts: Fonts = {
  Oswald: 'Oswald'
};
